<template>
    <form @submit.prevent="onSubmit" @keydown="form.errors.forget($event.target.name)">
        <div class="mb-3" :class="{ 'has-error' : form.errors.has('current_password') }">
            <label class="mb-1" for="current_password">{{ $t('settings.current_password') }}</label>
            <div class="input-group">
                <input class="form-control" id="current_password" name="current_password" :type="currentPasswordFieldType" v-model="form.current_password" />
                <span class="input-group-addon">
                    <label class="custom-control custom-control-primary custom-checkbox">
                        <input class="custom-control-input" type="checkbox" v-model="currentPasswordFieldType" true-value="text" false-value="password" @click="switchFieldVisibility('current_password')">
                        <span class="custom-control-indicator"></span>
                        <span class="custom-control-label">{{ $t('auth.show') }}</span>
                    </label>
                </span>
            </div>
            <p class="help-block" v-if="form.errors.has('current_password')" v-text="form.errors.get('current_password')"></p>
        </div>

        <div class="mb-3" :class="{ 'has-error' : form.errors.has('new_password') }">
            <label class="mb-1" for="new_password">{{ $t('settings.new_password') }}</label>
            <div class="input-group">
                <input class="form-control" id="new_password" name="new_password" :type="newPasswordFieldType" v-model="form.new_password" />
                <span class="input-group-addon">
                    <label class="custom-control custom-control-primary custom-checkbox">
                        <input class="custom-control-input" type="checkbox" v-model="newPasswordFieldType" true-value="text" false-value="password" @click="switchFieldVisibility('new_password')">
                        <span class="custom-control-indicator"></span>
                        <span class="custom-control-label">{{ $t('auth.show') }}</span>
                    </label>
                </span>
            </div>
            <p class="help-block" v-if="form.errors.has('new_password')" v-text="form.errors.get('new_password')"></p>
        </div>

        <div class="pt-2">
            <button class="btn btn-primary" :disabled="form.errors.any()" type="submit">
                {{ $t('settings.update_password') }}
            </button>
        </div>
    </form>
</template>

<script>
export default {
    data() {
        return {
            form: new Form({
                current_password: '',
                new_password: '',
            }),
            currentPasswordFieldType: 'password',
            newPasswordFieldType: 'password',
        };
    },

    methods: {
        switchFieldVisibility(field) {
            if (field === 'current_password') {
                this.currentPasswordFieldType = (this.currentPasswordFieldType === 'password') ? 'text' : 'password';
            }
            else if (field === 'new_password') {
                this.newPasswordFieldType = (this.newPasswordFieldType === 'password') ? 'text' : 'password';
            }
        },

        onSubmit() {
            Globals.put('/api/v1/settings/password', this.form)
                .then(() => window.location.reload())
                .catch(error => {
                    if (error.message !== 'The given data was invalid.') {
                        window.toastr.clear();
                        window.toastr.error(this.$t('globals.unexpected_error'));
                    }
                });
        },
    }
};
</script>
